// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-insurance-personal-v2/form-item-insurance-personal-v2.component.scss
// module id = 930
// module chunks = 0